import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth-service';
import { inject } from '@angular/core';

export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const accessToken = authService.getAccessToken()
  if (accessToken) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
